import React, { useState } from "react";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { Paper } from "@mui/material";
import { orderBy } from "lodash";
import { Box, Button, IconButton, Checkbox, Grid } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  getPopupGraphData,
  getScenarioModificationList,
  setState,
  approveQuota,
  getQuotaForApproval,
  approveModificationSingle,
} from "./quotaModificationSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuotaModificationTableRows,
  getScenarioModificationListRows,
} from "./quotaModificationUtils";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SmsIcon from "@mui/icons-material/Sms";
import {
  setState as setReviewState,
  GetUserCountries,
  GetOrderStatus,
  GetScenarios,
} from "../../Review/reviewSlice";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const OuterTable = ({ data }) => {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quotaModification);
  const {
    quotaList,
    countries,
    selectedRowsselected,
    scenarioName,
    scenarioModificationList,
    scenarioCanApproveReject,
    expandedRowIndex,
  } = state;
  const [rowsSelected, setrowsSelected] = useState([]);
  const [IsAllSelect, setIsAllSelect] = useState(false);
  const rows = getQuotaModificationTableRows(quotaList);
  //const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [orderByColumn, setOrderByColumn] = useState("");
  const [order, setOrder] = useState("asc");
  const handleRowClick = (params) => {
    const CountryID = params.row.geoId;
    const QuotaID = params.row.quotaId;
    dispatch(setState("scenarioCanApproveReject", params.row.canApproveReject));
    dispatch(setState("selectedScenarioCanEdit", params.row.canEdit));
    dispatch(setState("selectedModificationNumber", params.row.modificationNo));
    console.log("Approval_QuotaModification_getScenarioModificationList", {
      CountryID,
      QuotaID,
    });
    dispatch(getScenarioModificationList({ CountryID, QuotaID })).then(() => {
      //setExpandedRowIndex(params.row.id === expandedRowIndex ? null : params.row.id);
      dispatch(
        setState(
          "expandedRowIndex",
          params.row.id === expandedRowIndex ? null : params.row.id
        )
      );
    });
    dispatch(setState("scenarioName", params.row.scenarioName));
  };
  useEffect(() => {
    setrowsSelected(selectedRowsselected.map((row) => row.id));
  }, selectedRowsselected);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCheckboxChange = (event, row) => {
    const rowId = row.id;
    let idx = selectedRowsselected.findIndex((x) => x.id === rowId);
    let isSelected = idx > -1;
    let selRows = [...selectedRowsselected];

    if (isSelected) {
      selRows = selRows.filter((x) => x.id !== rowId);
    } else {
      selRows.push(row);
    }
    dispatch(setState("selectedRowsselected", selRows));
    setrowsSelected(selRows.map((row) => row.id));
    if (
      selRows.length === rows.filter((x) => x.canApproveReject === true).length
    ) {
      setIsAllSelect(true);
    } else {
      setIsAllSelect(false);
    }
  };
  const handleAllCheckboxChange = () => {
    if (!IsAllSelect) {
      let selRows = rows.filter((x) => x.canApproveReject === true);
      dispatch(setState("selectedRowsselected", selRows));
      setrowsSelected(selRows.map((row) => row.id));
      setIsAllSelect(true);
    } else {
      dispatch(setState("selectedRowsselected", []));
      setrowsSelected([]);
      setIsAllSelect(false);
    }
  };

  const handleRequestSort = (columnId) => {
    const isAsc = orderByColumn === columnId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderByColumn(columnId);
  };

  const paginatedData = orderBy(rows, orderByColumn, order).slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Grid>
      <TableContainer style={{ maxHeight: "calc(100vh - 130px)" }}>
        <Table component={Paper} style={{ overflowY: "auto" }} stickyHeader>
          <TableHead
            sx={{
              "& th": {
                backgroundColor: "rgb(235, 245, 255)",
              },
            }}
            style={{ cursor: "pointer" }}
          >
            <TableRow>
              <TableCell sx={{ width: 10 }}>
                <Checkbox
                  checked={IsAllSelect}
                  onChange={(e) => handleAllCheckboxChange()}
                />
              </TableCell>
              <TableCell onClick={() => handleRequestSort("scenarioName")}>
                Scenario
              </TableCell>
              <TableCell onClick={() => handleRequestSort("geoId")}>
                Country Code
              </TableCell>
              <TableCell>Graph</TableCell>
              <TableCell
                onClick={() => handleRequestSort("modificationStatus")}
              >
                Quota Status
              </TableCell>
              <TableCell onClick={() => handleRequestSort("modifiedQuota")}>
                Modified Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("previousQuota")}>
                Previous Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("differenceInQuota")}>
                Difference in Quota
              </TableCell>
              <TableCell onClick={() => handleRequestSort("lastActionDate")}>
                Last Action Date
              </TableCell>
              <TableCell onClick={() => handleRequestSort("lastActionBy")}>
                Last Action By
              </TableCell>
              <TableCell>Reject</TableCell>
              <TableCell>Approve</TableCell>
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData?.map((row, index) => (
              <React.Fragment key={row.id}>
                <TableRow>
                  <TableCell>
                    {row.canApproveReject && (
                      <Checkbox
                        checked={rowsSelected.includes(row.id)}
                        onChange={(e) => handleCheckboxChange(e, row)}
                      />
                    )}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.scenarioName}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {
                      countries.find((c) => c.countryID === row.geoId)
                        .countryCode
                    }
                  </TableCell>
                  <TableCell>
                    <ShowGraph row={row} />
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.modificationStatus}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.modifiedQuota?.toLocaleString()}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.previousQuota?.toLocaleString()}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.differenceInQuota?.toLocaleString()}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {" "}
                    {row.lastActionDate && (
                      <span>
                        {new Date(row.lastActionDate).toLocaleDateString(
                          "en-UK",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        )}
                      </span>
                    )}
                  </TableCell>
                  <TableCell onClick={() => handleRowClick({ row })}>
                    {row.lastActionBy}
                  </TableCell>
                  <TableCell>
                    <RejectButton row={row} />
                  </TableCell>
                  <TableCell>
                    <ApproveButton row={row} />
                  </TableCell>
                  <TableCell>
                    <EditButton row={row} />
                  </TableCell>
                </TableRow>
                {expandedRowIndex === row.id && scenarioModificationList && (
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell colSpan={11}>
                      <InnerTable />
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 50, 100]}
        component="div"
        count={rows?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end", // Align pagination to the right
          paddingRight: "16px", // Add some padding to prevent overlap
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};

const InnerTable = ({ data }) => {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quotaModification);
  const { scenarioModificationList, scenarioCanApproveReject } = state;

  const handleModificationClick = (params) => {
    dispatch(
      setState("selectedModificationNumber", params.item.modificationNo)
    );
  };
  const InfoRow = getScenarioModificationListRows(
    scenarioModificationList,
    scenarioCanApproveReject
  );
  return (
    InfoRow && (
      <TableContainer>
        <Table component={Paper} style={{ overflowY: "auto" }}>
          <TableHead
            sx={{
              "& th": {
                backgroundColor: "rgb(235, 245, 255)",
                fontSize: "12px",
              },
            }}
          >
            <TableRow>
              <TableCell>Modification No</TableCell>
              <TableCell>Modification Status</TableCell>
              <TableCell>Difference in Quota</TableCell>
              <TableCell>Last Action Date</TableCell>
              <TableCell>Last Action By</TableCell>
              <TableCell>Reject</TableCell>
              <TableCell>Approve</TableCell>
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& tr": {
                backgroundColor: "rgb(249, 251, 254)",
                fontSize: "12px",
              },
            }}
          >
            {InfoRow?.map((item) => (
              <TableRow key={item.modificationNo}>
                <TableCell onClick={() => handleModificationClick({ item })}>
                  {item.modificationNo}
                </TableCell>
                <TableCell onClick={() => handleModificationClick({ item })}>
                  {item.modificationStatus}
                </TableCell>
                <TableCell onClick={() => handleModificationClick({ item })}>
                  {item.differenceInQuota?.toLocaleString()}
                </TableCell>
                <TableCell onClick={() => handleModificationClick({ item })}>
                  {item.lastActionDate && (
                    <span>
                      {new Date(item.lastActionDate).toLocaleDateString(
                        "en-UK",
                        {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }
                      )}
                    </span>
                  )}
                </TableCell>
                <TableCell onClick={() => handleModificationClick({ item })}>
                  {item.lastActionBy}
                </TableCell>
                <TableCell>
                  <RejectModificationSingleButton row={item} />
                </TableCell>
                <TableCell>
                  <ApproveModificationSingleButton row={item} />
                </TableCell>
                <TableCell>
                  <EditModificationSingleButton row={item} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
};

function ShowGraph(params) {
  const dispatch = useDispatch();

  function getPopupData() {
    const obj = {
      scenarioID: params.row.scenarioId,
    };
    console.log("Approval_QuotaModification_DetailsButton", obj);
    dispatch(getPopupGraphData(obj));
    dispatch(setState("graphModalOpen", true));
  }

  return (
    <Button className={"closeButton2"} onClick={getPopupData}>
      Details
    </Button>
  );
}
function RejectButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  function openRejectModal() {
    dispatch(setState("selectedQuotaid", params.row.quotaId));
    dispatch(setState("rejectSelModalOpen", true));
  }
  if (params.row.canApproveReject && isRestrictedAccess) {
    return (
      <IconButton onClick={openRejectModal}>
        <CancelIcon sx={{ color: "red.main" }} />
      </IconButton>
    );
  }
  return null;
}

function ApproveButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quotaModification);
  const {
    selectedCountryID,
    selectedPeriod,
    selectedQuotaStatus,
    quotaList,
    searchText,
  } = state;

  function search() {
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRowsselected", []));
    dispatch(setState("scenarioModificationList", null));
    dispatch(setState("expandedRowIndex", null));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }

  function preparePayload() {
    let qList = [];
    const quota = quotaList.find(
      (quota) => quota.quotaId === params.row.quotaId
    );
    console.log(quota);
    const user = JSON.parse(localStorage.getItem("data"));
    console.log(user);
    const obj = {
      ...quota,
      user: user,
    };
    qList.push(obj);
    const country = user.userCountries.find(
      (index) => index.country.countryID === quota.geoId
    ).country;
    console.log(country);

    return qList;
  }

  function approve() {
    const qList = preparePayload();
    dispatch(approveQuota(qList)).then(() => {
      search();
    });
  }

  function approvewithComments() {
    const obj = preparePayload();
    dispatch(setState("selectedQuotaid", params.row.quotaId));
    dispatch(setState("appWithCommentModal", true));
  }
  if (params.row.canApproveReject && isRestrictedAccess) {
    return (
      <div>
        <IconButton onClick={approve}>
          <CheckCircleIcon sx={{ color: "green.main" }} />
        </IconButton>
        <IconButton onClick={approvewithComments}>
          <SmsIcon sx={{ color: "green.main" }} />
        </IconButton>
      </div>
    );
  }
  return null;
}

function EditButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ModApprovalState = useSelector((store) => store.quotaModification);
  const { quotaList, countries, selectedPeriod } = ModApprovalState;

  function gotoEditScenario() {
    const id = params.row.quotaId;
    const quota = quotaList.find((s) => s.quotaId === id);

    // #endregion
    dispatch(setReviewState("isNavigate", true));
    dispatch(GetUserCountries({ method: "Get" })).then(() => {
      dispatch(GetOrderStatus({ method: "Get" }));
    });
    navigate("/review/order");
    dispatch(
      setReviewState(
        "selectedCountry",
        countries.find((country) => country.countryID === quota.geoId)
          .countryName
      )
    );
    dispatch(setReviewState("selectedCountryID", quota.geoId));
    dispatch(setReviewState("searchTxt", quota.scenarioName));
    dispatch(setReviewState("selectedPeriod", selectedPeriod));
    dispatch(setReviewState("selectedOrderStatus", "All"));
    const obj = {
      countryID: quota.geoId,
      orderStatus: "All",
      searchText: quota.scenarioName,
      period: selectedPeriod,
    };

    dispatch(GetScenarios(obj));
    dispatch(setState("clearQCTable", true));
  }
  if (!params.row.canApproveReject && isRestrictedAccess) {
    return (
      <IconButton onClick={gotoEditScenario}>
        <EditNoteIcon sx={{ color: "blue.main" }} />
      </IconButton>
    );
  }
  return null;
}

function RejectModificationSingleButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();

  function openRejectModalSingle() {
    dispatch(setState("rejectScenarioModalSingleOpen", true));
    dispatch(setState("selectedModificationid", params.row.modificationId));
  }

  if (params.row.canApproveReject && isRestrictedAccess) {
    return (
      <IconButton onClick={openRejectModalSingle}>
        <CancelIcon sx={{ color: "red.main" }} />
      </IconButton>
    );
  }
  return null;
}

function ApproveModificationSingleButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const state = useSelector((store) => store.quotaModification);
  const {
    selectedCountryID,
    selectedPeriod,
    selectedQuotaStatus,
    scenarioModificationList,
    searchText,
    selectedModificationid,
  } = state;
  function search() {
    dispatch(setState("selectedRowsselected", []));
    dispatch(setState("scenarioModificationList", null));
    dispatch(setState("expandedRowIndex", null));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }

  function preparePayload() {
    let modification = scenarioModificationList.find(
      (item) => item.modificationId === params.row.modificationId
    );
    console.log(modification);
    const user = JSON.parse(localStorage.getItem("data"));
    console.log(user);
    const obj = {
      ...modification,
      user: user,
    };
    return obj;
  }

  function approve() {
    const qList = preparePayload();
    dispatch(approveModificationSingle(qList)).then(() => {
      search();
    });
  }
  function approvewithComments() {
    const obj = preparePayload();
    dispatch(setState("selectedModificationid", params.row.modificationId));
    dispatch(setState("appWithCommentModalSingle", true));
  }

  if (params.row.canApproveReject && isRestrictedAccess) {
    return (
      <div>
        <IconButton onClick={approve}>
          <CheckCircleIcon sx={{ color: "green.main" }} />
        </IconButton>
        <IconButton onClick={approvewithComments}>
          <SmsIcon sx={{ color: "green.main" }} />
        </IconButton>
      </div>
    );
  }
  //return null;
}

function EditModificationSingleButton(params) {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ModApprovalState = useSelector((store) => store.quotaModification);
  const { quotaList, countries, selectedPeriod, selectedScenarioCanEdit } =
    ModApprovalState;

  function gotoEditScenarioMod() {
    const id = params.row.quotaId;
    const quota = quotaList.find((s) => s.quotaId === id);

    // #endregion

    dispatch(GetUserCountries({ method: "Get" })).then(() => {
      dispatch(GetOrderStatus({ method: "Get" }));
    });
    navigate("/review/order");
    dispatch(
      setReviewState(
        "selectedCountry",
        countries.find((country) => country.countryID === quota.geoId)
          .countryName
      )
    );
    dispatch(setReviewState("selectedCountryID", quota.geoId));
    dispatch(setReviewState("searchTxt", quota.scenarioName));
    dispatch(setReviewState("selectedPeriod", selectedPeriod));
    dispatch(setReviewState("selectedOrderStatus", "All"));
    const obj = {
      countryID: quota.geoId,
      orderStatus: "All",
      searchText: quota.scenarioName,
      period: selectedPeriod,
    };

    dispatch(GetScenarios(obj));
    dispatch(setState("clearQCTable", true));
  }
  if (selectedScenarioCanEdit && isRestrictedAccess) {
    return (
      <IconButton onClick={gotoEditScenarioMod}>
        <EditNoteIcon sx={{ color: "blue.main" }} />
      </IconButton>
    );
  }
  return null;
}
// Example usage:
const App = () => {
  const outerData = [];

  return <OuterTable data={outerData} />;
};

export default App;
